import { DocumentItem } from "@covertree/ui/content/DocumentItem";

interface DocumentProps {
  document: File;
  removeDocument: (file: File) => void;
  isLoading?: boolean;
}

export default function Document({
  document,
  removeDocument,
  isLoading = false,
}: DocumentProps) {
  return (
    <DocumentItem
      name={document.name}
      actions={[
        {
          name: "Remove",
          onClick: () => removeDocument(document),
          isLoading,
        },
      ]}
    />
  );
}
